import  {useState } from 'react';
import { FilterBodyTemplate } from "../../../utils/configs";
import { APIEndpoint } from "../../../utils/axios";
import { DataGrid, UploadButton, EditModal, UploadModal } from "../../../common";
import { onDownloadXlsFile } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import searchIcon from '../../../assets/icons/search.svg';
import Edit2 from "../../../assets/edit2.svg";
import { MIMETypes } from '../../../utils/configs';
import LoadingGIF from '../../../assets/loadingIn.gif';
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import usePermissions from '../../../utils/userPermissions';
import {AlertModal } from "../../../common";
const DOWNLOAD_STATUS_CHECK_DELAY = 8000;

const Columns = [
  { field: 'itemCode', headerName: 'Item Code', flex:1,suppressSizeToFit:true, resizable:true,minWidth: 235,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
  { field: 'itemName', headerName: 'Name',flex:1,suppressSizeToFit:true, resizable:true, minWidth: 255,tooltipField: 'itemName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  } },
  // { field: 'perFlightQuantity', headerName: 'Per Flight',flex:1,suppressSizeToFit:true, resizable:true, minWidth: 125 },
  { field: 'singleSector', headerName: 'Single Sector',flex:1,suppressSizeToFit:true, resizable:true, minWidth: 125 },
  { field: 'doubleSector', headerName: 'Double Sector',flex:1,suppressSizeToFit:true, resizable:true, minWidth: 125 },
  { field: 'tripleSector', headerName: 'Triple Sector',flex:1,suppressSizeToFit:true, resizable:true, minWidth: 125 },
  { field: 'multiSector', headerName: 'Multi Sector', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 200}
];
const FormFields = [
  { label: 'Item Code', attribute: 'itemCode', type: 'text', required: true, disabled: true },
  { label: 'Item Name', attribute: 'itemName', type: 'text', disabled: true },
  { label: 'Per Flight', attribute: 'perFlightQuantity', type: 'text' },
  { label: 'Single Sector', attribute: 'singleSector', type: 'text' },
  { label: 'Double Sector', attribute: 'doubleSector', type: 'text' },
  { label: 'Triple Sector', attribute: 'tripleSector', type: 'text' },
  { label: 'Multi Sector', attribute: 'multiSector', type: 'text' },
]

export const StandardItemsPage = () => {
  const { t,ready } = useTranslation();
  const [state, setState] = useState({ resetDataSource: false, editRow: null });
  const [errorObj] = useState(null)
  const [isDownloading, setIsDownloading] = useState(false);
  const [searchKey, setSearchKey] = useState('');
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  
  const modelStyle = { maxWidth: '60%', margin: 'auto 10% 100% 10%' };

  const { hasPermission: editStdItem } = usePermissions('edit', "configuration.standard-items");
  const { hasPermission: uploadStdItem } = usePermissions('upload', "configuration.standard-items");


  const fetchStandardItems = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    const filterData = JSON.parse(JSON.stringify(FilterBodyTemplate));
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    const res = await APIEndpoint.post('estimation/standarditems/process', filterData);
    if (res.items) {
      res.items = res.items.map((_) => {
        return {
          ..._,
          percentageText: `${_.percentage}%`
        }
      })
    }
    return res;
  }
  const handleAction = async (_, __, selectedRowData) => {
    setState((_) => {
      return { ..._, editRow: selectedRowData }
    })
  };

  const onSearch = (e) => {
    setSearchKey(e.target.value);
};


  const handleReset = (e, reset) => {
    setState((_) => {
      return { ..._, resetDataSource: reset ? true : state.resetDataSource, editRow: null };
    })
    setModalFormStatusObj({text:""})
    if (reset) {
      let timerId = setTimeout(() => {
        clearTimeout(timerId);
        setState((_) => {
          return { ..._, resetDataSource: false };
        })
      }, 500)
    }
  }
  const handleFormSubmit = async (e, values) => {

      try {
        values = { ...state.editRow, ...values };
        const res = await APIEndpoint.post('estimation/standarditems/update/' + state.editRow.itemCode, values);
        if (res.success) {
          setModalFormStatusObj({text:res.msg})
          setTimeout(()=>{
            handleReset(null, true)
          },1500)
        }
      } catch (error) {
        // alert('Error While updating Standard Item')
        let {data}=JSON.parse(error?.message);
        setModalFormStatusObj({ error: data?.msg });
      }

  }
  const onDownloadSampleFile = async (e) => {
    onDownloadXlsFile('samples/downloads/Standard_Items_Upload_Sample', 'Standard_Items_Upload_Sample')
  }
  
  const showDownloadErrorAlert = (message) => {
    setState((_) => {
      return { ..._, downloadStandardItemsError: true, message: { 
        title: 'Download Error', 
        text: message || "Something went wrong!"
      }, };
    });
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        downloadStandardItemsError: false,
        message: null,
      }));
    }, 5000);

  }

  const onDownloadStandardItems=async()=>{
    const headers = {
      'Accept':'text/csv'
    };

    try {
      setIsDownloading(true);

      const res= await APIEndpoint.post(`downloads/standardItems`, {}, headers);
      if(res.status==='scheduled') {

        setTimeout(() => {
          setIsDownloading(true);
          const downloadPromise = APIEndpoint.get(`downloads/status/${res.id}`);
          downloadPromise.then( (val) => {

            if (val.status === "completed") {

              APIEndpoint.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                .then((DownloadResp) => {
                  const url = window.URL.createObjectURL(new Blob([DownloadResp]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `Standard-Items_${new Date().toISOString().replace(/:/g, '-')}${val.fileExtension}`);
                  document.body.appendChild(link);
                  link.click();
                  setIsDownloading(false);
                })
                .catch((error) => {
                  console.error('Log: Error downloading file:', error);
                  setIsDownloading(false);
                  const errorTxt = JSON.parse( error?.message );
                  showDownloadErrorAlert( errorTxt?.data?.message || "Something went wrong!");
                });
            }
            else if (val.status === "failed") {
              setIsDownloading(false);
              showDownloadErrorAlert( val?.data?.message || "Something went wrong!");
            }
            else {
              console.error('Log: Retry download again after some time.');
              setIsDownloading(false);
              showDownloadErrorAlert( "Something went wrong!");
            }
          })
          .catch( (error) => {
            console.error('Log: Error while checking download status:', error);
            setIsDownloading(false);
            const errorTxt = JSON.parse( error?.message );
            showDownloadErrorAlert( errorTxt?.data?.message || "Something went wrong!");
          });

        }, DOWNLOAD_STATUS_CHECK_DELAY);
      }
    }
    catch (error) {
      setIsDownloading(false);
      console.error('Log: Error while downloading:', error);
      const errorTxt = JSON.parse( error?.message );
      showDownloadErrorAlert( errorTxt?.data?.message || "Something went wrong!");
    }
  }

const onUploadClose=()=>{
  setState((_) => ({ ..._, showUpload: false }))
  setUploadedFile([]);
  setUploadFileStatusBlock('');
}
  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('scheduleLater', false);
    formData.append('listName', undefined);
    formData.append('targetSectorType', undefined);
    formData.append('stores', undefined);
    formData.append('warehouses', undefined);
    formData.append('file', file);

    try {
      await APIEndpoint.post('standarditems/upload', formData);
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
      setState( (_prev) => {
        return { ..._prev,resetDataSource:true}
      });

    }
    catch(error) {

      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400) {
        if(data.errors){
                data.errors?.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push( erObj.field + ' | ' + erObj.message + ' \n<br>' );
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
        }else{
          msgContent += `Failed to upload items sheet.`;
        }
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading items sheet!<br>Please try again.`;
    }
      else {
        msgContent += `Error occurred while uploading items sheet!<br>Please fix the errors and re-upload.`;
      }
      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};

  const handleOnContinue = async () => {
    setState( (prevState) => ({
      ...prevState,
      downloadStandardItemsError: false,
      message: null,
    }));
  }

  return (
    <div className="device-page op-aircraft-container flexCol full-flex ag-theme-alpine-dark">


      <div className='flexRow width100 justifyContentSpaceBetween'>
          <div className='flexRow width100 justifyContentCenter alignItemsCenter'>
              <div className="underline">
                  <span><img  className="icon-size" alt={t('filters.searchText')} src={searchIcon} /></span>
                  <span><input className="search" onChange={onSearch} type="search" placeholder={t('filters.searchText')} value={searchKey}/></span>
              </div>
          </div>

            <div className='flexRow width100 justifyContentFlexEnd'>
            <div className="flexRow justifyContentFlexEnd alignItemsBaseline">
                {uploadStdItem?<UploadButton
                label={t('pages.estimationsContent.standardItems.uploadItems')}
                className=""
                showLabel={false}
                onClick={() => setState((_) => ({ ..._, showUpload: true }))}
                />:null}&nbsp;
                {uploadStdItem? <div className="flexRow justifyContentFlexStart margRight">

                {isDownloading ? (
                <button className="margRight" title={t('filters.downloadingMaster')}>
                <img
                src={LoadingGIF}
                className="margBottom0 icon-size-min"
                alt="Loading"
                />
                </button>
                ) : (
                <div  title={"Download Standard Items"}>
                <button
                onClick={onDownloadStandardItems}
                className="margRight"
                style={{ cursor: 'pointer' }}
                title={"Download Standard Items"}
                >
                <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                </button></div>

                )
                }

                </div>:<></>}

            </div>
            </div>

          </div>
      <DataGrid
        columnResize
        showDefaultFilters
        enableGridSearch={false}
        className='full-flex'
        columns={Columns}
        searchKey={searchKey}
        getRows={fetchStandardItems}
        actions={[
          { detail: editStdItem?[{ src: Edit2, value: "edit",title:'Edit' }]:[] }
        ]}
        onAction={handleAction}
        resetDataSource={state.resetDataSource}
      />
      {
        Boolean(state.editRow) && (
          <EditModal
            title={t('pages.estimationsContent.standardItems.editModalTitle')}
            onClose={handleReset}
            onSubmit={handleFormSubmit}
            alignStart
            buttonLabel={t('buttons.save')}
            modalFormStatusObj={modalFormStatusObj}
            fields={
              FormFields.map((elt) => {
                const isEdit = Boolean(state.editRow)
                return { ...elt, initialValue: isEdit ? state.editRow[elt.attribute] : '' }
              })
            }
          />
        )
      }
      {
        state.showUpload &&
        <UploadModal
          modelTitle={t('pages.estimationsContent.standardItems.uploadItems')}
          onUploadClose={onUploadClose}
          onDownloadSampleFile={onDownloadSampleFile}
          errorObj={errorObj}
          uploadedFile = { uploadedFile }
          onUploadFileChangeHandler = { (e) => onUploadFileChangeHandler(e) }
          uploadFileStatusBlock = { uploadFileStatusBlock }
          allowedExtensions={ MIMETypes.excel }
        />
      }
       {
        !ready &&<div className='overlay_hide sub'></div>
        }

        {
          Boolean(state.downloadStandardItemsError) && (
          <AlertModal
              title={state.message?.title || 'Error'}
              customModalStyle={ modelStyle }
              description={ state.message?.text || 'Something went wrong!' }
              onContinue={handleOnContinue}
              onClose={handleOnContinue}
          />
          )
        }
    </div>
    
  )
}
